import { CustomTooltip } from '@components/CustomTooltip'
import TruncateLines from '@components/TruncateLines'
import { Link } from '@mui/material'

import { CellInfo } from '../types'

export const CompanyCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
  } = info

  if (!profileData.companyName) {
    return null
  }

  return (
    <CustomTooltip title={profileData.companyName} placement="top" arrow={false} padding="5">
      <Link
        href={`/plus/profile/${profileData.companyId}/company`}
        underline="none"
        style={{ wordBreak: 'break-word', fontWeight: '700' }}
      >
        <TruncateLines lines={5}>{profileData.companyName}</TruncateLines>
      </Link>
    </CustomTooltip>
  )
}
